// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>s
//     </div>
//   );
// }

// export default App;

import React, { useState } from 'react';
import axios from 'axios';
import { Container, Form, Button, Table, Nav, Tab } from 'react-bootstrap';
import './App.css';

const EMICalculator = () => {
  const [amount, setAmount] = useState('');
  const [rate, setRate] = useState('');
  const [period, setPeriod] = useState('');
  const [isYearly, setIsYearly] = useState(false);
  const [schedule, setSchedule] = useState([]);
  const [summary, setSummary] = useState(null);

  const handleCalculate = async () => {
    const response = await axios.post('/api/calculateEMI', {
      amount: parseFloat(amount),
      rate: parseFloat(rate),
      period: parseInt(period),
      isYearly,
    });

    setSchedule(response.data.schedule);
    setSummary(response.data.summary);
  };

  return (
    <div className="calculator-container">
      <h2 className="calculator-title">EMI Calculator</h2>
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Loan Amount</Form.Label>
          <Form.Control
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter loan amount"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Interest Rate (%)</Form.Label>
          <Form.Control
            type="number"
            value={rate}
            onChange={(e) => setRate(e.target.value)}
            placeholder="Enter interest rate"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Period</Form.Label>
          <Form.Control
            type="number"
            value={period}
            onChange={(e) => setPeriod(e.target.value)}
            placeholder="Enter period"
          />
          <div className="mt-3 toggle-switch-container">
            <span className={`toggle-label ${!isYearly ? 'active' : ''}`}>Months</span>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={isYearly}
                onChange={(e) => setIsYearly(e.target.checked)}
              />
              <span className="toggle-slider"></span>
            </label>
            <span className={`toggle-label ${isYearly ? 'active' : ''}`}>Years</span>
          </div>
        </Form.Group>
        <Button
          className="w-100 mb-3"
          variant="primary"
          onClick={handleCalculate}
        >
          Calculate EMI
        </Button>
      </Form>

      {summary && (
        <div className="summary-card">
          <h3>Summary</h3>
          <div className="summary-item">
            <span>Loan Amount:</span>
            <strong>{parseFloat(summary.loanAmount).toLocaleString()}</strong>
          </div>
          <div className="summary-item">
            <span>Interest Rate:</span>
            <strong>{summary.interestRate}</strong>
          </div>
          <div className="summary-item">
            <span>Period:</span>
            <strong>{summary.period}</strong>
          </div>
          <div className="summary-item">
            <span>Monthly EMI:</span>
            <strong>{parseFloat(summary.monthlyEMI).toLocaleString()}</strong>
          </div>
          <div className="summary-item">
            <span>Total Interest:</span>
            <strong>
              {parseFloat(summary.totalInterest).toLocaleString()}
            </strong>
          </div>
          <div className="summary-item">
            <span>Total Payment:</span>
            <strong>
              {parseFloat(summary.totalPayment).toLocaleString()}
            </strong>
          </div>
        </div>
      )}

      {schedule.length > 0 && (
        <div className="table-responsive">
          <Table striped bordered hover className="schedule-table">
            <thead>
              <tr>
                <th>Month</th>
                <th>Interest Payment</th>
                <th>Principal Payment</th>
                <th>Remaining Principal</th>
              </tr>
            </thead>
            <tbody>
              {schedule.map((item) => (
                <tr key={item.month}>
                  <td>{item.month}</td>
                  <td>{parseFloat(item.interestPayment).toLocaleString()}</td>
                  <td>{parseFloat(item.principalPayment).toLocaleString()}</td>
                  <td>
                    {parseFloat(item.remainingPrincipal).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

const AgeCalculator = () => {
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [birthDate, setBirthDate] = useState('');
  const [currentDate, setCurrentDate] = useState(getTodayDate());
  const [ageResult, setAgeResult] = useState(null);

  const calculateAge = () => {
    if (!birthDate) {
      alert('Please select your birth date');
      return;
    }

    const birth = new Date(birthDate);
    const current = new Date(currentDate);

    if (birth > current) {
      alert('Birth date cannot be in the future');
      return;
    }

    let years = current.getFullYear() - birth.getFullYear();
    let months = current.getMonth() - birth.getMonth();
    let days = current.getDate() - birth.getDate();

    if (days < 0) {
      months--;
      const lastMonth = new Date(current.getFullYear(), current.getMonth(), 0);
      days += lastMonth.getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    // Calculate total days
    const totalDays = Math.floor((current - birth) / (1000 * 60 * 60 * 24));
    const totalMonths = years * 12 + months;
    const totalWeeks = Math.floor(totalDays / 7);

    setAgeResult({
      years,
      months,
      days,
      totalDays,
      totalMonths,
      totalWeeks,
    });
  };

  return (
    <div className="calculator-container">
      <h2 className="calculator-title">Age Calculator</h2>
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Birth Date</Form.Label>
          <Form.Control
            type="date"
            value={birthDate}
            onChange={(e) => setBirthDate(e.target.value)}
            max={currentDate}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Current Date</Form.Label>
          <Form.Control
            type="date"
            value={currentDate}
            onChange={(e) => setCurrentDate(e.target.value)}
            max={getTodayDate()}
          />
        </Form.Group>
        <Button className="w-100 mb-3" variant="primary" onClick={calculateAge}>
          Calculate Age
        </Button>
      </Form>

      {ageResult && (
        <div className="age-result">
          <h3 className="age-result-title">Your Age</h3>
          <div className="age-cards-container">
            <div className="age-card blue-card">
              <div className="age-value">{ageResult.years}</div>
              <div className="age-label">Years</div>
            </div>
            <div className="age-card blue-card">
              <div className="age-value">{ageResult.months}</div>
              <div className="age-label">Months</div>
            </div>
            <div className="age-card blue-card">
              <div className="age-value">{ageResult.days}</div>
              <div className="age-label">Days</div>
            </div>
          </div>
          <div className="age-details">
            <div className="detail-item">
              <span>Total Days:</span>
              <strong>{ageResult.totalDays.toLocaleString()}</strong>
            </div>
            <div className="detail-item">
              <span>Total Months:</span>
              <strong>{ageResult.totalMonths.toLocaleString()}</strong>
            </div>
            <div className="detail-item">
              <span>Total Weeks:</span>
              <strong>{ageResult.totalWeeks.toLocaleString()}</strong>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const App = () => {
  return (
    <Container fluid className="app-container">
      <div className="app-header">
        <h1>Financial Tools</h1>
      </div>
      <Tab.Container defaultActiveKey="emi">
        <Nav variant="tabs" className="custom-tabs">
          <Nav.Item>
            <Nav.Link eventKey="emi">EMI Calculator</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="age">Age Calculator</Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="emi">
            <EMICalculator />
          </Tab.Pane>
          <Tab.Pane eventKey="age">
            <AgeCalculator />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </Container>
  );
};

export default App;
